import type { LauncherNavItem } from '@features/tenant/launcherNavigation';

export interface ChromeIdentity {
  logoUrl: string;
  name: string;
  monogram: string;
}

export const chromeIdentity = (
  logoUrl: string,
  brandName: string,
): ChromeIdentity => {
  const name = brandName.trim();
  return {
    logoUrl,
    name: brandName,
    monogram: name ? [...name][0].toUpperCase() : '',
  };
};

const withoutTrailingSlash = (path: string) =>
  path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;

export const isActiveSection = (currentPath: string, itemPath: string) => {
  const current = withoutTrailingSlash(currentPath);
  const item = withoutTrailingSlash(itemPath);
  return current === item || current.startsWith(`${item}/`);
};

export const activeSection = (
  currentPath: string,
  items: LauncherNavItem[],
): LauncherNavItem | undefined =>
  items.find((item) => isActiveSection(currentPath, item.path));
